import { useSelector, useDispatch } from 'react-redux'
import styled from 'styled-components'
import PageTopTitle from '../../components/shared/PageTopTitle'
import { useEffect, useState } from 'react'
import { getGibKestigimFaturalar, sendConfirmationSms, setSelectedGibInvoice, viewEArsivInvoice } from '../../features/e-Arsiv/eArsivSlice'
import { showModal } from '../../features/modal/modalSlice'
import InputDate from '../../components/shared/input/new/InputDate'
import { getDatee } from '../../helper/getDatee'
import dateConverter from '../../helper/dateConverter'


const Container = styled.div`
  width: 100%;
  height: 100%;
    .wrapper{
      width: 100%;
      padding: 30px;
      .top-container{
        display: flex;
        align-items: center;
        gap: 20px;
        margin-bottom: 30px;
      }
      .content{
        width: 100%;
        display: flex;

        .table{
        width: 100%;
        border-collapse: collapse;

        thead{
            width: 100%;
            background-color: var(--color-main);

            tr{

                th{
                    color: #fff;
                    padding: 10px 15px;
                    border-right: 1px solid #fff;
                    font-size: var(--font-size-sm);
                    font-weight: var(--font-weight-lg);
                    text-align: center;

                    &:first-child{
                        border-left: 1px solid var(--color-main);
                        text-align: start;
                    }

                    &:last-child{
                        border-right: 1px solid var(--color-main);
                    }

                    .title-text{
                        width: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;

                        .sort-icon{
                            font-size: 1rem;
                            cursor: pointer;
                        }
                    }

                }
            }
        }

        tbody{

            tr{
                td{

                    border: 1px solid ${({theme}) => theme.mainTextColor};
                    text-align: start;
                    font-size: var(--font-size-sm);
                    font-weight: var(--font-weight-lg);
                    padding: 10px 15px;
                    text-align: center;

                    &:first-child{
                        text-align: start;
                    }

                    input{
                        width: 100%;
                        text-align: center;
                    }
                }
                .option{
                  cursor: pointer;
                  color: var(--color-main);
                  .accept-delete{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                  }
                }
            }

        }
    }

      }
    }
`

const titles = ["Döküman Numarası", "Düzenleme Tarihi", "Alıcı Vergi/TC No", "Alıcı Adı Soyadı", "Durumu", "İşlem"]


const KestigimEArsivFaturalarim = () => {

  const {gibKestigimFaturaList, viewEArsivInvoiceData, selectedGibInvoice} = useSelector(state => state.eArsiv)

  const dispatch = useDispatch()
  
  const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;

  const gibCallId = JSON.parse(storage.getItem("gibCallId"))
  const gibCallIdCount = JSON.parse(storage.getItem("gibCallIdCount"))
  const gibToken = JSON.parse(storage.getItem("gibToken"))

  const [data, setData] = useState({
    startDate: getDatee() ,
    endDate: getDatee()
  })
  
  useEffect(() => {
    dispatch(getGibKestigimFaturalar({
      authInfoDto:{
      token: gibToken,
      callId: gibCallId,
      callIdCount: gibCallIdCount+1
    },
      filterStartDate: dateConverter(data?.startDate, "tr") ,
      filterEndDate:  dateConverter(data?.endDate, "tr")
    }))
  },[gibCallId, gibCallIdCount, gibToken, data?.endDate, data?.startDate])

  const handleDetayView = (item) => {
    const body = {
      uuid: item?.uuid,
      authInfoDto: {
        token:gibToken,
        callId: gibCallId,
        callIdCount: gibCallIdCount
      },
      isApproved: item?.approvalStatus === "Onaylandı" ? true : false
    }
    dispatch(viewEArsivInvoice(body))
  }

  const handleOnayla = (item) => {
    dispatch(setSelectedGibInvoice(item))
    
    dispatch(sendConfirmationSms({
      authInfoDto: {
        token:gibToken,
        callId: gibCallId,
        callIdCount: gibCallIdCount
      }
    }))
  }

  const handleDeleteSignedInvoice = (item) => {
    dispatch(setSelectedGibInvoice(item))
    dispatch(showModal("cancelGibEarsivInvoice"))
  }

  const handleChange = (e) => {
    setData((prev) => ({...prev, [e?.target?.name]: e?.target?.value}))
  }

  return (
    <Container>
      <PageTopTitle title={"Kestiğim e-Arşiv Faturalarım"} position='sticky' top='210px'/>

      <div className="wrapper">
          <div className="top-container">
            <InputDate data={data?.startDate} setData={(e) => handleChange(e)} name={"startDate"} labelText={"Başlangıç Tarihi"} inputWidth={"200px"} />
            <InputDate data={data?.endDate} setData={(e) => handleChange(e)} name={"endDate"} labelText={"Bitiş Tarihi"} inputWidth={"200px"} />
          </div>
          <div className="content">
            
            <table className="table">
              <thead>
                  <tr>
                      {
                          titles.map((item, i) => (
                              <th key={i}>{item}</th>
                          ))
                      }
                  </tr>
              </thead>
              <tbody>
              {
                gibKestigimFaturaList?.map((item) => (
                    <tr>
                        <td>{item.documentNumber}</td>
                        <td>{item.documentDate}</td>
                        <td>{item.vknTckn}</td>
                        <td>{item.recipientName}</td>
                        <td >{item.approvalStatus}</td>
                        {
                          item.approvalStatus === "Onaylandı" || "Silinmiş" ?
                          <td className='option'>
                            <div className="accept-delete">
                              <span  onClick={() =>handleDetayView(item)}>Görüntüle</span>
                              <span>/</span>
                              <span onClick={() => handleDeleteSignedInvoice(item)}>İptal Talebi</span>
                            </div>
                          </td>
                          :
                          <td className='option'>
                            <div className='accept-delete'>
                              <span onClick={() => handleOnayla(item)}>Onayla</span>
                              <span>|</span>
                              <span onClick={() => {dispatch(showModal("deleteGibEarsivInvoice")); dispatch(setSelectedGibInvoice(item))}}>Sil</span>
                            </div>
                          </td>
                        }
                    </tr>
                ))
              }
              </tbody>
            </table>

          </div>
        </div>
    </Container>
  )
}

export default KestigimEArsivFaturalarim